export default "__VITE_PUBLIC_ASSET__44f68d7f__"